module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('span', [_c('em', [_vm._v("For those in my family who traveled far in company of service members, and those who waited at home in times of war:")])])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('span', [_c('em', [_vm._v("Florence Bear")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Earl Bear")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Irene Garrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("George Garrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Lorraine Garrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Lynn Garrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Dan Garrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Kathleen Garrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Colleen Garrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Devin Garrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Barbara Julian")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('em', [_vm._v("Wilma Bear")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793dbbbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0